/**
 * Creates the payload emitted when the uploader modal requests to close.
 */
export function createUploaderClosePayload({hasUploads = false, openStorageUpsell = false} = {}) {
  return {
    hasUploads: Boolean(hasUploads),
    openStorageUpsell: Boolean(openStorageUpsell)
  };
}
